import { render, staticRenderFns } from "./results.vue?vue&type=template&id=4a33ab74&scoped=true&"
import script from "./results.vue?vue&type=script&lang=ts&"
export * from "./results.vue?vue&type=script&lang=ts&"
import style0 from "./results.vue?vue&type=style&index=0&id=4a33ab74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33ab74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
